import CouponsCards from '../../components/Coupons/CouponsCards';
import ListingPage from '../../components/ListingPage';

const CouponsPage = () => {
  return <ListingPage createRestrictionKey="couponsCreate" entityType="coupon" filterBy="name" Cards={CouponsCards} />;
};

export default CouponsPage;
